var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 233,
    height: 228.261,
    viewBox: "0 0 233 228.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1334 -421)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16452 10.261)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17797.902 408.829)",
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.134 1.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.468,109.245C180.459,75.546,182.8,41,172.19,24.761S129.965-19.483,55.264,29.312s-55.7,101.837-44.028,119.7C65.866,232.642,241.451,168.927,202.468,109.245Z",
    transform: "translate(-0.134 -1.91)",
    fill: "#e6fffc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.634 3.588)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H5.819V11.639H0Z",
    transform: "translate(0 4.114) rotate(-45)",
    fill: "#e6fffb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 23.666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H11.639V5.819H0Z",
    transform: "translate(0 8.228) rotate(-45)",
    fill: "#e6fffb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.657 0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H11.639V5.819H0Z",
    transform: "translate(0 8.228) rotate(-45)",
    fill: "#e6fffb"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.383 142.871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.479,44.208a8.729,8.729,0,1,1,8.729-8.729A8.74,8.74,0,0,1,35.479,44.208Zm0-11.639a2.91,2.91,0,1,0,2.91,2.91A2.914,2.914,0,0,0,35.479,32.569Z",
    transform: "translate(-6.75 -1.75)",
    fill: "#e6fffb"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.5,
    cy: 9.5,
    rx: 116.5,
    ry: 9.5,
    transform: "translate(17786 620)",
    fill: "#e6fffc",
    opacity: 0.68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1377.244 452.176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.029,59.74a35,35,0,1,0-54.658-6.576L1.234,113.3l11.743,11.743,7.067-7.067,7.673,7.673,10.861-10.861-7.673-7.673L42.153,95.867l7.673,7.673L60.687,92.679l-7.673-7.673,20.1-20.1a35.006,35.006,0,0,0,42.915-5.167Z",
    transform: "translate(0 0)",
    fill: "#00bfa3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17149.938,479.5l9.563,9.562,18.344-18.345",
    transform: "translate(-15696 6.476)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordReset);
export default __webpack_public_path__ + "static/media/password-reset.8fb9a9167692413fe952d3ba3cbf2a0a.svg";
export { ForwardRef as ReactComponent };